
import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/models/Card";

@Component
export default class CardTemplate extends Vue {
  @Prop() card!: Card;
}
